import {store} from '@csrc/redux/storeConfig/store'

export const fillMissingData = (data) => {
  if (_.size(data) === 0) {
    return []
  }
  const dates = []
  const filterStart = store.getState().analytics?.filters?.date_from
  const filterEnd = store.getState().analytics?.filters?.date_to
  const start = filterStart ?? data[0].date
  const end = filterEnd ?? _.last(data).date
  const startDate = new Date(start) // year, month (0-indexed), day
  const endDate = new Date(end)

  for (let d = startDate; d <= endDate; d.setDate(d.getDate() + 1)) {
    dates.push(new Date(d))
  }

  return dates.map(date => {
    const dateString = date.toISOString().substring(0, 10)
    const point = data.find(p => p.date === dateString)
    return {
      date: dateString,
      value: point && parseInt(point?.value) > 0 ? parseInt(point?.value) : 0
    }
  })
}

export const groupedByYear = (data) => {
  return _.map(_.groupBy(data, function(item) {
    return item.date.substring(0, 4)
  }), (x, key) => {
    return {
      date: key,
      value: _.sumBy(x, a => a.value)
    }
  })
}

export const groupedByMonth = (data, calculateAverageInGrouping) => {
  return _.map(_.groupBy(data, function(item) {
    return item.date.substring(0, 7)
  }), (x, key) => {
    return {
      date: key,
      value: calculateAverageInGrouping ? _.meanBy(x, a => a.value) : _.sumBy(x, a => a.value)
    }
  })
}

export const getSuitableData = (data, type = null, calculateAverageInGrouping) => {
  const allDataByDays = fillMissingData(data)
  switch (type) {
    case 'days' :
      return allDataByDays
    case 'months':
      return groupedByMonth(allDataByDays, calculateAverageInGrouping)
    case 'years':
      return groupedByYear(allDataByDays, calculateAverageInGrouping)
    default:
      const size = _.size(allDataByDays)
      if (size <= 31) {
        return allDataByDays
      } else if (size <= 366) {
        return groupedByMonth(allDataByDays, calculateAverageInGrouping)
      } else {
        return groupedByYear(allDataByDays, calculateAverageInGrouping)
      }
  }
}

export const getAvailableRanges = (data) => {
  const size = _.size(fillMissingData(data))
  switch (true) {
    case (size > 366):
      return 3
    case (size > 31) :
      return 2
    default:
      return 1
  }
}

export const convertDivToPng = (divId) => {

}

export const convertDivToSvg = (divId) => {

}

export const treeToFlat = (data, parentId = null, filterLeafTypes = []) => {
  return _.chain(data)
    .flatMap(item => {
      // Check if the item has children
      const hasChildren = item.children && item.children.length > 0
      const currentItem = _.omit(item, 'children')
      const flatItem = {
        ...currentItem, 
        parent_id: parentId, 
        hasChildren 
      }
      if (hasChildren) {
        const filteredChildren = treeToFlat(item.children, item.id, filterLeafTypes)
        if (filteredChildren.length > 0) {
          return [flatItem, ...filteredChildren]
        } else {
          return []
        }
      } else {
        if (_.size(filterLeafTypes) > 0) {
          return _.includes(filterLeafTypes, item.type) ? flatItem : null
        } else {
          return flatItem
        }
      }
    })
    .compact()
    .value() 
}

export const generateChartColors = (totalColors) => {
  const colors = []
  const distinctColors = Math.ceil(totalColors / 3) // Dividing total colors to ensure some variations in hue
  for (let index = 0; index < totalColors; index++) {
    const hue = Math.floor((index % distinctColors) / distinctColors * 360) // Distributes hues for distinct colors
    const saturation = 90 // Keeps colors vivid
    const lightness = 40 + (index % 3) * 20 // Lightness variations: 40%, 60%, 80% for each color
    colors.push(`hsl(${hue}, ${saturation}%, ${lightness}%)`)
  }
  return colors
}

export const formatterDataGroupedByAsset = (params) => {
  const data = _.map(params.data, data => ({ date: data.response_at, data }))
  const sortedData = _.sortBy(data, 'date')
  const datesXAxis = _.uniq(_.map(sortedData, i => i.date))
  const series = []
  const allAsset = _.groupBy(data, (item) => item.data.asset_id)
  _.forEach(allAsset, (assetQuestions, assetId) => {
    const allQuestions = _.groupBy(assetQuestions, (items) => items.data.item_base_uuid)
    _.forEach(allQuestions, (questions, questionId) => {
      const questionsDataKeyByDate = _.keyBy(questions, 'date')
      const questionsData = _.map(questionsDataKeyByDate, (question, date) => {
          return {
            x: date,
            y: _.get(question, 'data.answer', ''),
            question: _.get(params.labels, questionId, ''),
            asset: _.get(params.assets, assetId, '')
          }
      })
      const question = _.get(params.labels, questionId, '')
      const asset = _.get(params.assets, assetId, '')
      const assetTitle = asset ? `(${asset})` : ''
      series.push({ name: `${question} ${assetTitle}`, questionId, question, assetId, asset,  type: 'line', data: questionsData })
    })
  })
  const colors = generateChartColors(_.size(series))
  return { labels: datesXAxis, series: _.map(series, (item, index) => ({...item, color: colors[index]})) }
}

export const formatterDataGroupedByNone = (params) => {
  const data = _.map(params.data, data => ({ date: data.response_at, data }))
  const sortedData = _.sortBy(data, 'date')
  const datesXAxis = _.uniq(_.map(sortedData, i => i.date))
  const series = []
  const questionsGrouped = _.groupBy(data, (item) => item.data.item_base_uuid)
  _.forEach(questionsGrouped, (questions, questionId) => {
    const questionsData = _.map(questions, (question, date) => {
      return {
        x: _.get(question, 'date', ''),
        y: _.get(question, 'data.answer', ''),
        question: _.get(params.labels, questionId, ''),
        asset: _.get(params.assets, question?.data?.asset_id, '')
      }
    })
    const question = _.get(params.labels, questionId, '')
    series.push({ name: question, questionId, type: 'line', data: questionsData })
  })
  const colors = generateChartColors(_.size(series))
  return { labels: datesXAxis, series: _.map(series, (item, index) => ({...item, color: colors[index]})) }
}